
































import Vue from 'vue'
import New from '@/components/New.vue'
import FooterItem from '@/components/FooterItem.vue'

export default Vue.extend({
  name: 'news',
  components: {
    New,
    FooterItem
  },
  data: function () {
    return {
      news: [
        {
          title: 'ICT&D participa en el congreso Smart City Expo World.',
          img: {
            src: 'assets/img/news/new-01.jpg',
            alt: 'ICT&D participa en el congreso Smart City Expo World'
          },
          date: '15 de Noviembre 2018',
          article:
            'Partners de ICT&D estuvieron presentes en Smart City Expo World, en una misión conjunta gracias al apoyo de Asturex. Smart City Expo World Congress existe para empoderar a las ciudades y colectivizar la innovación urbana en todo el mundo. A través de la promoción de la innovación social, el establecimiento de asociaciones y la identificación de oportunidades de negocios, el evento está dedicado a crear un mejor futuro para las ciudades y sus ciudadanos en todo el mundo.'
        },
        {
          title: 'Participación en el programa de identificación temprana de oportunidades en Washington de ASTUREX ',
          img: {
            src: 'assets/img/news/piwas.jpg',
            alt: 'Participación en el programa de identificación temprana de oportunidades en Washington de ASTUREX'
          },
          date: '12 de Diciembre',
          article:
            ' ICT&D se suma al Programa PIWAS de identificación temprana de oportunidades en Washington organizado por Asturex. Este programa tiene por objetivo prestar un servicio de consultoría estratégica para el acceso a licitaciones internacionales en Washington a través del Banco Mundial y el Banco Interamericano de Desarrollo (BID).'
        },
        {
          title: 'IV Encuentros Internacionales Sector TIC',
          img: {
            src: 'assets/img/news/IV-encuentros-internacionales-sector-TIC.jpg',
            alt: 'IV Encuentros Internacionales Sector TIC'
          },
          date: '10 de Octubre de 2018',
          article:
            'Los cuartos Encuentros Internacionales del Sector TIC, celebrados en el marco del evento “Smart Cities and Communities”, contaron con la presencia de ICT&D IFIS Partners, que se entrevistaron con distintas empresas y organismos de América y Europa para explorar oportunidades de colaboración.'
        },
        {
          title: 'Presentación del consorcio en la Jornada “Smart Cities and Communities',
          img: {
            src: 'assets/img/news/Smart-Cities-and-Communities.png',
            alt: 'Presentación del consorcio en la Jornada “Smart Cities and Communities'
          },
          date: '9 de Octubre de 2018',
          article:
            'Durante la jornada “Smart Cities and Communities” organizada ASTUREX en colaboración con el Clúster TIC de Asturias, los socios de ICT&D contaron su experiencia como consorcio en el ámbito de las licitaciones para organismos multilaterales.'
        },
        {
          title: 'Programa de el Acceso al Mercado Multilateral (PAMM)',
          img: {
            src: 'assets/img/news/pamm.jpg',
            alt: 'Programa de el Acceso al Mercado Multilateral (PAMM)'
          },
          date: '3 de julio 2018',
          article:
            'ICT&D participa en el programa PAMM de ASTUREX, dirigido a empresas asturianas interesadas en acceder a los mercados multilaterales. Este programa ha sido diseñado para mejorar, consolidar y hacer crecer las exportaciones posicionando los productos y servicios asturianos en mercados internacionales mediante la participación en licitaciones multilaterales.'
        }
      ]
    }
  }
})
